import { FC } from "react";

import { Box } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import Link from "@components/Link";
import { Mobile } from "@lib/media";
import { useAuth } from "@modules/auth";

import useSaveForLater from "../../hooks/summary/useSaveForLater";

const SaveForLaterAction: FC = () => {
  const { t } = useTranslation();

  const { isLoggedIn } = useAuth();

  const { saveForLater } = useSaveForLater();

  const handleSaveForLaterClick = () => saveForLater();
  if (!isLoggedIn) {
    return null;
  }

  return (
    <Mobile>
      <Box>
        <Link onClick={handleSaveForLaterClick} label={t("order-action-save_for_later")} size="lg" isUnderlined />
      </Box>
    </Mobile>
  );
};
export default SaveForLaterAction;
